import { createContentPropTypes } from '../../helpers/content';

const content = {
	awaitingAuthTitle: 'Payments awaiting authorisation',
	byYouTabLabel: 'By you',
	byOthersTabLabel: 'By another user',
	refreshButtonText: 'Refresh',
	noPaymentsByMe: "You don't have any payments to authorise right now.",
	noPaymentsByOthers: "There aren't any payments awaiting authorisation by other users right now",
	expiredTitle: 'Cancelled payments',
	expiredSubText:
		"The following payments have been cancelled as they weren't authorised on time. If they still have to be made they'll have to be set up and authorised again.",
	expiredReminderText:
		'Please remember that repeating payments must be authorised by 4pm on the day before the first payment is due. ',
	expiredCloseButtonText: 'Close',
	twoStepFailed: 'Something went wrong.',
	twoStepSuccess:
		'Step one of the payment authorisation is complete. Please log in to your mobile banking app to provide final authorisation.',
	refreshButton: 'Refresh',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
